import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import { MentionList } from './List';
export const mention = ({ document, search, cachedMentions, }) => ({
    items: () => [],
    decorationTag: 'a',
    render: () => {
        let reactRenderer;
        let popup;
        return {
            onStart: props => {
                reactRenderer = new ReactRenderer(MentionList, {
                    props: { ...props, search, cachedMentions },
                    editor: props.editor,
                });
                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.getElementById('composer-editor-wrapper') || document.body,
                    content: reactRenderer.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    popperOptions: {
                        strategy: 'fixed',
                    },
                    placement: 'bottom-start',
                });
            },
            onUpdate(props) {
                reactRenderer.updateProps(props);
                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                });
            },
            onKeyDown(props) {
                var _a;
                if (props.event.key === 'Escape') {
                    popup[0].hide();
                    return true;
                }
                return (_a = reactRenderer.ref) === null || _a === void 0 ? void 0 : _a.onKeyDown(props);
            },
            onExit() {
                popup[0].destroy();
                reactRenderer.destroy();
            },
        };
    },
});
//# sourceMappingURL=options.js.map